"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureSubscriptionPopup = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _api = require("../../api");
var _Button = _interopRequireDefault(require("../Button"));
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _checkmarkBase = _interopRequireDefault(require("../../assets/images/checkmarkBase"));
var _planHelper = require("../../util/planHelper");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _InnerPopupWrapperStyled = require("../InnerPopupWrapper/InnerPopupWrapperStyled");
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _innerPopupReducer = require("../../redux/innerPopupReducer");
var _PauseSubscriptionPopupStyled = require("./PauseSubscriptionPopupStyled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Close = function Close(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a", "{", "fill:#cb4477", "}")), /*#__PURE__*/_react.default.createElement("path", {
    className: "a",
    d: "M83.448 13.624V0H0v80.042h11.921v11.921h81.745V13.624ZM3.406 76.636V3.406h76.636v10.218H11.921v63.012ZM90.26 88.557H15.327V17.03H90.26Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "a",
    d: "M67.244 38.343a1.7 1.7 0 0 0-2.408 0L52.793 50.385 40.751 38.343a1.703 1.703 0 0 0-2.408 2.408l12.042 12.042-12.042 12.042a1.703 1.703 0 1 0 2.408 2.408l12.042-12.042 12.042 12.043a1.703 1.703 0 0 0 2.408-2.408L55.201 52.793l12.043-12.042a1.7 1.7 0 0 0 0-2.408Z"
  }));
};
Close.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "93.667",
  height: "91.963"
};
var PauseSubscriptionPopup = function PauseSubscriptionPopup(_ref) {
  var toOffer = _ref.toOffer,
    fromOffer = _ref.fromOffer,
    hideInnerPopup = _ref.hideInnerPopup,
    showInnerPopup = _ref.showInnerPopup,
    updateList = _ref.updateList,
    isPopupLoading = _ref.isPopupLoading,
    t = _ref.t;
  var STEPS = {
    PAUSE_DETAILS: 'PAUSE_DETAILS',
    CONFIRMATION: 'CONFIRMATION'
  };
  var STEPS_NUMBERS = {
    PAUSE_DETAILS: 1,
    CONFIRMATION: 2
  };
  var _useState = (0, _react.useState)(STEPS.PAUSE_DETAILS),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isError = _useState6[0],
    setError = _useState6[1];
  var pauseSubscription = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var resp;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return (0, _api.subscriptionSwitch)(fromOffer.offerId, toOffer.toOfferId, toOffer.switchDirection);
          case 4:
            resp = _context.sent;
            if (!resp.errors.length) {
              (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_SUCCESSFUL, {
                fromOfferId: fromOffer.offerId,
                toOfferId: toOffer.toOfferId,
                switchDirection: toOffer.switchDirection,
                algorithm: toOffer.algorithm
              });
              setIsLoading(false);
              setStep(STEPS.CONFIRMATION);
            } else {
              (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_FAILED, {
                reason: resp.errors[0]
              });
              setError(true);
              setIsLoading(false);
            }
            _context.next = 13;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_FAILED);
            setError(true);
            setIsLoading(false);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function pauseSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var closePopupAndRefresh = function closePopupAndRefresh() {
    hideInnerPopup();
    updateList();
  };
  if (isPopupLoading) {
    return /*#__PURE__*/_react.default.createElement(_InnerPopupWrapper.default, {
      steps: 2,
      popupTitle: t('Pausing plan'),
      currentStep: 1
    }, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
      showChildren: false,
      height: 200,
      width: 450,
      margin: "auto"
    }));
  }
  if (isError) {
    return /*#__PURE__*/_react.default.createElement(_InnerPopupWrapper.default, {
      steps: 3,
      popupTitle: t('Pausing plan'),
      currentStep: STEPS_NUMBERS[step] + 1
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ContentStyled, null, /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.ImageWrapper, null, /*#__PURE__*/_react.default.createElement(Close, null)), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TitleStyled, {
      step: step
    }, t('An error occurred.')), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TextStyled, {
      step: step
    }, t('We have been unable to pause your plan as an error occurred. Sorry for the inconvenience, please try again.'))), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ButtonWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: "confirm",
      onClickFn: closePopupAndRefresh
    }, t('Back to My Account')))));
  }
  var pauseStartingDate = (0, _planHelper.dateFormat)(fromOffer.expiresAt);
  var offerTitle = fromOffer.offerTitle;
  return /*#__PURE__*/_react.default.createElement(_InnerPopupWrapper.default, {
    steps: 3,
    popupTitle: t('Pausing plan'),
    currentStep: STEPS_NUMBERS[step] + 1
  }, step === STEPS.PAUSE_DETAILS && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ContentStyled, null, /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.SubscriptionIconStyled, {
    period: fromOffer.period,
    showLabel: "Current",
    gray: true
  }), /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.ArrowStyled, null), /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.SubscriptionIconStyled, {
    isPaused: true,
    showLabel: "Paused"
  })), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TitleStyled, {
    step: step,
    textTransform: "capitalize"
  }, t('Subscription pause')), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TextStyled, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "pausesubscriptionpopup-info"
  }, "On your next billing cycle (", /*#__PURE__*/_react.default.createElement("strong", null, {
    pauseStartingDate: pauseStartingDate
  }), ") your subscription pause will go into effect. While your subscription is paused, you won\u2019t be charged for, and you won\u2019t have access to,", ' ', {
    offerTitle: offerTitle
  }, ". You can resume your ", {
    offerTitle: offerTitle
  }, ' ', "subscription at any time.")), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TextStyled, null, t('pausesubscriptionpopup-note', 'Or, if you don`t do anything, your subscription will automatically resume at the start of the next season. When your subscription resumes, you will be billed the current monthly subscription fee for your plan.')), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TextStyled, {
    step: step
  }, t('Would you like to pause?'))), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
    removeMargin: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: "simple",
    onClickFn: function onClickFn() {
      showInnerPopup({
        type: _innerPopupReducer.POPUP_TYPES.updateSubscription,
        data: {
          action: 'unsubscribe',
          offerData: _objectSpread({}, fromOffer)
        }
      });
    }
  }, t('Back')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: "confirm",
    onClickFn: pauseSubscription
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    buttonLoader: true,
    color: "#ffffff"
  }) : t('Pause subscription')))), step === STEPS.CONFIRMATION && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ContentStyled, null, /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_PauseSubscriptionPopupStyled.ImageStyled, {
    src: _checkmarkBase.default,
    alt: "checkmark icon"
  })), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TitleStyled, {
    step: step
  }, t('Your pause request has been confirmed.')), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.TextStyled, {
    step: step
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "pausesubscriptionpopup-confirm"
  }, "You will continue to have access to your subscription through your current billing cycle. The pause will go into effect on", ' ', /*#__PURE__*/_react.default.createElement("strong", null, {
    pauseStartingDate: pauseStartingDate
  })))), /*#__PURE__*/_react.default.createElement(_InnerPopupWrapperStyled.ButtonWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: "confirm",
    onClickFn: closePopupAndRefresh
  }, t('Back to My Account')))));
};
exports.PureSubscriptionPopup = PauseSubscriptionPopup;
PauseSubscriptionPopup.propTypes = {
  toOffer: _propTypes.default.objectOf(_propTypes.default.any),
  fromOffer: _propTypes.default.objectOf(_propTypes.default.any),
  hideInnerPopup: _propTypes.default.func,
  updateList: _propTypes.default.func,
  isPopupLoading: _propTypes.default.bool,
  t: _propTypes.default.func,
  showInnerPopup: _propTypes.default.func
};
PauseSubscriptionPopup.defaultProps = {
  toOffer: {},
  fromOffer: {},
  hideInnerPopup: function hideInnerPopup() {},
  showInnerPopup: function showInnerPopup() {},
  updateList: function updateList() {},
  isPopupLoading: false,
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(PauseSubscriptionPopup));
exports.default = _default;